import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "hooks/morning/axiosInstanse";

interface Request {
    category: string;
}
export type PopupDataListProps = {
    idx: number;
    vPopSizeW: string;
    vPopSizeH: string;
    vPopX: string;
    vPopY: string;
    cTodayYN: string;
    cPvL: string;
    vTitle: string;
    vContent: string;
};

export type ResponseData = PopupDataListProps[];

export const useGetPopups = ({ category }: Request): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_popups.replace(":category", category);
    return useQuery({
        queryKey: ["useGetPopups", category],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
    });
};
